import TRANSLATION_ACCESSIBILITY_ZH_HANS from './accessibility/translation';
import TRANSLATION_BOOKING_ZH_HANS from './booking/translation';
import TRANSLATION_EVENTS_ZH_HANS from './events/translation';
import TRANSLATION_EXPERIENCES_ZH_HANS from './experiences/translation';
import TRANSLATION_FORM_ZH_HANS from './form/translation';
import TRANSLATION_LANDING_PAGES_ZH_HANS from './landingPages/translation';
import TRANSLATION_RESERVE_ZH_HANS from './reserve/translation';
import TRANSLATION_SIGNIN_ZH_HANS from './signin/translation';
import TRANSLATION_DATES_ZH_HANS from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_ZH_HANS,
  ...TRANSLATION_BOOKING_ZH_HANS,
  ...TRANSLATION_EVENTS_ZH_HANS,
  ...TRANSLATION_EXPERIENCES_ZH_HANS,
  ...TRANSLATION_FORM_ZH_HANS,
  ...TRANSLATION_LANDING_PAGES_ZH_HANS,
  ...TRANSLATION_RESERVE_ZH_HANS,
  ...TRANSLATION_SIGNIN_ZH_HANS,
  ...TRANSLATION_DATES_ZH_HANS,
};
